export default {
	home: '首页',
	about: '走进我们',
	services: '服务项目',
	contact: '联系我们',
	shipping: '运输服务',
	refrigerated: '冷藏货物',
	operable: '操作性货物',
	consultation: '产品合规咨询',
	business: '商务合作',
	recruitment: '招贤纳士',
	switchLanguage: '切换语言',
	language: '中文',
	english: 'English',
	contactUs: '联系我们',
	homeTitle: "泛思特国际运输", // 泛思特国际运输
	homeSubtitle: "专业 · 安全 · 高效", // 专业 安全 高效
	header: {
		findLocation: '查找网点',
		getSolution: '获取方案'
	},
	homeFst: {
		bannerTitle: '专业物流解决方案',
		bannerDesc: '为您提供高效、安全、可靠的全球运输服务',
		services: {
			title: '专业运输解决方案',
			tag: '我们的服务',
			list: [{
					title: '冷链运输',
					desc: '提供全温区精准控制的冷链运输解决方案，确保温控产品运输质量始终如一',
					features: ['全温区覆盖', '实时温度监控系统', '医药级冷链包装', '7×24小时智能预警，异常情况即时响应']
				},
				{
					title: '危险品运输',
					desc: '国际认证的危险品运输专家，提供全品类危险货物的安全运输解决方案',
					features: ['国际认证资质', '专业危险品处理团队', '合规化运输方案', '应急响应系统']
				},
				{
					title: '医药化工运输',
					desc: '符合GMP标准的专业运输服务，满足医药化工品的高标准运输需求',
					features: ['GMP标准运输环境', '专业温控系统', '操作全程可视化', '质量合规保障']
				},
				{
					title: '带电货物运输',
					desc: '锂电池及含电设备专业运输服务，符合国际运输标准',
					features: ['符合国际标准的锂电池安全包装', '专业隔离措施', 'IATA/IMDG合规', '安全运输认证']
				},
				{
					title: '重型与异形货物运输',
					desc: '针对重型设备及异形货物，提供高效、安全的专业运输方案，全面满足工程机械、特种设备等大件货物的全球运输需求',
					features: ['专属装卸定制方案', '精确运输路径规划', '配备特种运输装备', '覆盖全球的门到门服务']
				},
				{
					title: '高效定制化服务',
					desc: '提供高效、定制化的专业货物运输服务',
					features: ['定制化运输方案', '全程跟踪，安全保障']
				}
			]
		},
		stats: {
			years: '合作航司',
			airlines: '员工人数',
			routes: '自营仓库',
			customers: '服务企业',
		},
		partners: {
			title: '合作伙伴',
			subtitle: '携手全球知名航空公司与船运公司，为您提供优质物流服务',
			airlineTitle: '航空合作伙伴',
			shippingTitle: '海运合作伙伴',
		},
		news: {
			title: '新闻动态',
			subtitle: '了解泛思特最新资讯与行业动态',
			readMore: '阅读更多',
			items: [
				{
					date: '2026-05-20',
					title: '泛思特成功取得CEIV Pharma认证',
					summary: '泛思特国际货运正式通过IATA CEIV Pharma认证，标志着公司在医药冷链物流领域达到国际最高标准。',
				},
				{
					date: '2026-04-15',
					title: '泛思特成都分公司正式开业',
					summary: '随着西南地区航空物流需求持续增长，泛思特正式设立成都分公司，进一步完善全国网络布局。',
				},
				{
					date: '2026-03-08',
					title: '泛思特荣获WCA年度最佳代理奖',
					summary: '在2026年WCA全球年会上，泛思特凭借卓越的服务品质和客户满意度，荣获年度最佳代理大奖。',
				},
			],
		},
	},
	aboutFst: {
		companyImageCaption: "北京总部办公室",
		stats: {
			airlines: "签约知名航司",
			clients: "服务企业",
			employees: "员工人数",
			warehouse: "自营仓库"
		},
		title: "走进泛思特",
		heroTitle: "走进泛思特",
		companyIntro: {
			title: "公司简介",
			subtitle: "一站式国际运输解决方案服务商",
			qualifications: {
				title: "公司资质",
				part1: '北京泛思特国际运输代理有限公司是由中国民航总局批准的一级货运代理公司，国际民航组织IATA会员单位，成立于2005年，迄今共有 ',
				highlight: '北京、上海、广州、郑州、成都',
				part2: '五个运营站点。'
			},
			coreBusiness: {
				title: "核心业务",
				services: [
					"医药冷链",
					"生物制药",
					"普货运输",
					"危险品运输",
					"锂电产品",
					"异形货运输",
					"门到门服务"
				]
			},
			advantages: {
				title: "服务优势",
				items: [{
						title: "航空资源",
						content: "自签约航司20余家，覆盖全球主要航线网络"
					},
					{
						title: "专业团队",
						content: "260+专业人员，提供全流程服务"
					},
					{
						title: "企业客户",
						content: "服务12000+生产、销售及贸易进出口企业"
					},
					{
						title: "仓储设施",
						content: "6200㎡+自营仓库，含恒温/冷藏/冷冻库"
					}
				]
			},
			mission: {
				title: "服务理念",
				prefix: '以',
				keywords1: ['诚信'],
				keywords2: '为本，秉持',
				keywords: ['专业、优质、高效', '互联网科技、人工智能', '门到门全链条'],
				middle1: '的服务理念，结合',
				middle2: '的创新模式，构建强大的全球货物运输网络，为客户提供',
				suffix: '运输解决方案。'
			}
		},
		quickServices: [
			{ icon: 'fa fa-truck', title: '货运保障' },
			{ icon: 'fa fa-link', title: '全程供应链' }
		],
		checkItems: [
			'安全准时的运输服务',
			'一体化仓储与配送',
			'为您量身定制的物流解决方案'
		],

		certificates: {
			title: "资质证书",
			subtitle: "专业认证保障运输安全",
			clickHint: "点击查看大图",
			cert1: "中国航空运输协会-会员证书",
			cert1Authority: "中国航空运输协会",
			cert1Validity: "长期有效",
			cert2: "质量管理体系认证证书",
			cert2Authority: "方圆标志认证集团",
			cert2Validity: "2024-2027",
			cert3: "WCA危险品专项会员",
			cert3Authority: "WCA World Cargo Alliance",
			cert3Validity: "2025年度",
			cert4: "WCA医药专项会员",
			cert4Authority: "WCA World Cargo Alliance",
			cert4Validity: "2025年度",
			cert5: "冷库温度显示装置检定报告",
			cert5Authority: "计量检定机构",
			cert5Validity: "定期检定",
			cert6: "民航服务认证证书",
			cert6Authority: "中国民航科学技术研究院",
			cert6Validity: "2024-2027",
			cert7: "IATA危险品运输资质认证",
			cert7Authority: "IATA国际航空运输协会",
			cert7Validity: "年度审核",
			cert8: "GSP认证",
			cert8Authority: "药品监督管理局",
			cert8Validity: "认证有效",
		},
		memberships: {
			title: "证书会员",
			subtitle: "国际权威组织认证，保障全球服务品质",
			iata: "IATA国际航空运输协会",
			wca: "WCA世界货运联盟",
			wcaDangerous: "WCA危险品专项会员",
			jctrans: "JCtrans国际物流平台",
			jctransCert: "JCtrans认证会员"
		},
		memberLogos: {
			title: "会员认证",
			subtitle: "国际权威组织会员单位",
			member1: "IATA国际航空运输协会",
			member2: "WCA世界货运联盟",
			member3: "DGM危险品管理",
			member4: "中国民航科学技术研究院",
			member5: "上海化工研究院",
		},
		timeline: {
			title: "发展历程",
			subtitle: "我们的重要里程碑",
			events: [{
					year: "2025",
					content: "AI 加持，开启智能货代新纪元",
				},
				{
					year: "2024",
					content: "成都分公司成立，服务西南地区客户",
				},
				{
					year: "2023",
					content: "取得民航局危险品货运代理认证",
				},
				{
					year: "2022",
					content: "郑州分公司成立，中原枢纽布局完成",
				},
				{
					year: "2020",
					content: "成功保障疫情期间医药冷链物资运输，彰显企业社会责任",
				},
				{
					year: "2019",
					content: "加入DGLN和WCA国际组织，国际业务能力全面提升",
				},
				{
					year: "2018",
					content: "广州分公司成立，覆盖华南市场，全国布局初步形成",
				},
				{
					year: "2016",
					content: "上海分公司成立，业务拓展至华东地区",
				},
				{
					year: "2008",
					content: "获得IATA危险品运输资质认证，业务步入规范化发展轨道",
				},
				{
					year: "2005",
					content: "泛思特在北京成立<br/>专注危险品航空运输代理业务",
				}
			]
		},
		branches: {
			title: "立足全国",
			subtitle: "覆盖全国主要经济区域的运输网络",
			beijing: {
				city: "北京总部",
				year: "2005",
				cityWithYear: "北京总部",
				desc: "北京泛思特国际运输代理有限公司成立于2005年，是经国家商务部和中国航协批准的一级货运代理公司，专业从事化学品、危险品、医药冷链、锂电产品、高端消费品等货物的国际出口运输业务。",
				officeArea: "1821㎡",
				warehouseArea: "2935㎡"
			},
			shanghai: {
				city: "上海分公司",
				year: "2016",
				cityWithYear: "上海分公司",
				desc: "北京泛思特国际运输代理有限公司(上海分公司)主营业务包括空运、海运、内陆运输。拥有独立990㎡仓储部，自建多温区冷库。",
				officeArea: "400㎡",
				warehouseArea: "990㎡"
			},
			guangzhou: {
				city: "广州分公司",
				year: "2018",
				cityWithYear: "广州分公司",
					desc: "北京泛思特国际运输代理有限公司(广州分公司)主营国际空运、内陆运输、港、澳、大湾区联运等业务。办公区域约200㎡，拥有独立的660㎡仓储部，自建冷库。",
				officeArea: "290㎡",
				warehouseArea: "660㎡"
			},
			zhengzhou: {
				city: "郑州分公司",
				year: "2022",
				cityWithYear: "郑州分公司",
				desc: "北京泛思特国际运输代理有限公司(郑州分公司)成立于2022年，办公面积112㎡，拥有独立的430㎡仓储部。",
				officeArea: "112㎡",
				warehouseArea: "440㎡"
			},
			chengdu: {
				city: "成都分公司",
				year: "2023",
				cityWithYear: "成都分公司",
				desc: "北京泛思特国际运输代理有限公司(成都分公司)成立于2023年，拥有独立的1170㎡仓储部。",
				officeArea: "50㎡",
				warehouseArea: "1170㎡"
			}
		},
		common: {
			established: "年成立",
			officeArea: "办公面积",
			warehouseArea: "仓储面积",
			loading: "加载中"
		},
	},
	hero: {
		eyebrow: '核心服务',
		title: '全球物流解决方案专家',
		subtitle: '泛思特国际运输 - 连接世界每一个角落'
	},
	NavigationServices: {
		airTag: '航空网络',
		airTitle: '泛思特航司协作链',
		airDescription: '泛思特国际运输自签约航司20余家，覆盖欧、美、南美、东南亚、印度、中东、非洲、澳洲等全球航线网络',
		seaTag: '海运矩阵',
		seaTitle: '泛思特·海运矩阵',
		seaDescription: '与全球主要船公司合作，提供全球范围的海运服务',
		wcaTitle: "WCA会员",
		wcaDescription: "泛思特是WCA（World Cargo Alliance）世界货运联盟组织成员，能够在世界各地提供全面服务，确保全球各地的客人都能获得最具价值的服务，同时确保您的货物得以最佳操作。"
	},
	refrigeratedGoods: {
		tag: "冷链运输",
		title: "冷藏货物种类",
		subtitle: "精准温控 · 全程可视 · 安全可靠",
		introduction: "我们为药品、生物制剂、化工产品、生鲜食品等温度敏感货物提供专业温控服务，确保您的货物在整个运输过程中保持最佳状态。",
		viewDetails: "查看详情",
		tempRangeTitle: "我们的温控范围",
		tempRecorder: {
			title: "实时温度数据",
			altText: "温度记录仪",
			downloadBtn: "下载完整报告",
			data: [{
					label: "当前温度",
					value: "22.5°C",
					highlight: false
				},
				{
					label: "平均温度",
					value: "21.8°C",
					highlight: false
				},
				{
					label: "最高温度",
					value: "25.2°C",
					highlight: true
				},
				{
					label: "最低温度",
					value: "18.3°C",
					highlight: true
				},
				{
					label: "温度波动",
					value: "±1.2°C",
					highlight: false
				},
				{
					label: "记录时长",
					value: "36小时",
					highlight: false
				}
			]
		},
		features: [{
				icon: "fas fa-temperature-low",
				title: "精准温控",
				description: "±1°C精确控制，满足各类敏感货物需求",
				color: "#4a89dc"
			},
			{
				icon: "fas fa-map-marked-alt",
				title: "全程可视",
				description: "GPS定位+温度实时监控，运输全程可视化",
				color: "#3bafda"
			},
			{
				icon: "fas fa-shield-alt",
				title: "安全保障",
				description: "专业团队+应急预案，确保货物万无一失",
				color: "#37bc9b"
			},
			{
				icon: "fas fa-file-alt",
				title: "完整报告",
				description: "提供运输全程温度记录和分析报告",
				color: "#f6bb42"
			}
		],
		tempRanges: [{
				temp: "-25°C",
				label: "超低温冷冻",
				color: "#4fc1e9"
			},
			{
				temp: "-18°C",
				label: "标准冷冻",
				color: "#5d9cec"
			},
			{
				temp: "2-8°C",
				label: "冷藏",
				color: "#a0d468"
			},
			{
				temp: "15-25°C",
				label: "恒温",
				color: "#ffce54"
			},
			{
				temp: "30°C+",
				label: "高温控制",
				color: "#ed5565"
			}
		],
		activeControl: {
			title: "主动温控服务",
			subtitle: "实时监控 · 自动调节 · 数据记录",
			equipment: [{
					name: "RKN t2 干冰箱",
					image: "rknT2.jpeg",
					description: "适用于-18°C冷冻运输，内置锂电池供电系统",
					specs: [{
							icon: "fas fa-thermometer-half",
							text: "-25°C至+25°C"
						},
						{
							icon: "fas fa-battery-full",
							text: "72小时续航"
						},
						{
							icon: "fas fa-weight",
							text: "45kg"
						}
					]
				},
				{
					name: "RAP e2 插电箱",
					image: "RLP.jpg",
					description: "新一代温控箱，支持远程监控和调节",
					specs: [{
							icon: "fas fa-thermometer-half",
							text: "±1°C精度"
						},
						{
							icon: "fas fa-wifi",
							text: "实时数据传输"
						},
						{
							icon: "fas fa-ruler-combined",
							text: "1200×800×800mm"
						}
					]
				},
				// {
				// 	name: "海尔温控箱",
				// 	image: "Haier.jpg",
				// 	description: "冷藏恒温控制，适用于药品运输",
				// 	specs: [{
				// 			icon: "fas fa-thermometer-half",
				// 			text: "+0°C~+25°C"
				// 		},
				// 		{
				// 			icon: "fas fa-chart-line",
				// 			text: "温度曲线记录"
				// 		},
				// 		{
				// 			icon: "fas fa-bell",
				// 			text: "异常报警"
				// 		}
				// 	]
				// },
				{
					name: "混动式冷藏箱 skyCell",
					image: "混动.jpeg",
					description: "混合动力恒温控制，集成温度曲线实时记录、断电与温差多级报警、远程监控等功能，适用于高价值医药品冷链运输，保障运输过程全程可视、可控、可溯源。",
					specs: [{
							icon: "fas fa-thermometer-half",
							text: "+0 °C～+25 °C 恒温"
						},
						{
							icon: "fas fa-chart-line",
							text: "实时温度记录"
						},
						{
							icon: "fas fa-bell",
							text: "异常与断电报警"
						}
					]
				}
				,
				{
					name: "欧宝利温控箱",
					image: "ouboli.png",
					description: "专业主动温控解决方案，精准温度控制，适用于医药、生物制剂等高价值温敏货物的长途运输。",
					specs: [{
							icon: "fas fa-thermometer-half",
							text: "+2°C～+8°C"
						},
						{
							icon: "fas fa-satellite-dish",
							text: "远程实时监控"
						},
						{
							icon: "fas fa-shield-alt",
							text: "多重安全保护"
						}
					]
				}

			]
		},
		passiveControl: {
			title: "被动温控服务",
			subtitle: "经济高效 · 灵活定制 · 航点无忧",
			options: [{
					icon: "pmx.jpg",
					title: "泡沫箱解决方案",
					description: "经济高效的温控包装方案",
					color: "#8cc152",
					features: [
						"多种尺寸可选",
						"可定制分隔",
						"适合短途冷链运输",
						"支持72小时"
					]
				},
				{
					icon: "bp.jpg",
					title: "制冷剂组合",
					description: "根据需求配置最佳制冷方案",
					color: "#3bafda",
					features: [
						"干冰/冰排/冰袋",
						"精确计算用量",
						"温度持续时间可控",
						"环保材料"
					]
				},
				{
					icon: "dz.jpg",
					title: "定制包装",
					description: "针对特殊货物的专属解决方案",
					color: "#da4453",
					features: [
						"一对一定制服务",
						"多层保温结构",
						"抗震防摔"
					]
				}
			]
		}
	},
	cargoTypes: {
		title: '可操作货物种类',
		subtitle: '专业处理各类货物，完全符合安全规范',
		general: {
			title: '普通货物',
			description: '常规货物安全运输解决方案',
			commonItems: '生物制品材料、制剂、纺织品、精细化工、原料药、电子产品、机械配件、食品等:',
			tags: [
				'生物制品材料',
				'制剂',
				'纺织品',
				'精细化工',
				'原料药',
				'电子产品',
			]
		},
		dangerous: {
			title: '危险品',
			description: '专业危险品运输解决方案',
			classes: [{
					class: '1类<br>爆炸品',
					name: '',
					note: '根据危险等级分为1.1-1.6项',
				},
				{
					class: '2类<br>气体',
					name: '',
					subclass: '易燃气体 / 非易燃气体 / 毒性气体',
					example: '气雾剂、打火机',
					unNumber: 'UN1950 / UN1075',
				},
				{
					class: '3类<br>易燃液体',
					name: '',
					subclass: '',
					example: '油漆、酒精、汽油',
					unNumber: 'UN1203 / UN1170',
				},
				{
					class: '4类<br>易燃、自燃、遇水释放易燃气体物质',
					name: '',
					subclasses: [{
							subclass: '4.1类 易燃固体',
							name: '',
							example: '酒精湿巾、肽粉',
							unNumber: 'UN1331',
						},
						{
							subclass: '4.2类 自燃物质',
							name: '',
							example: '肽粉',
							unNumber: 'UN1350',
						},
						{
							subclass: '4.3类 遇水放出易燃气体的物质',
							name: '',
							example: '氢化钙',
							unNumber: 'UN1404',
						},
					],
				},
				{
					class: '5类<br>氧化剂和有机过氧化货物',
					name: '',
					subclasses: [{
							subclass: '5.1类 氧化剂',
							name: '',
							example: '硝酸钾、过氧化氢',
							unNumber: 'UN2067 / UN1942',
						},
						{
							subclass: '5.2类 有机过氧化物',
							name: '',
							example: '过氧化物、硬化剂',
							unNumber: 'UN3105 / UN1942',
						},
					],
				},
				{
					class: '6类<br>毒害与感染性物质',
					name: '',
					subclasses: [{
							subclass: '6.1类 毒害品',
							name: '',
							example: '喜树碱、流感病毒毒株',
							unNumber: 'UN1541',
						},
						{
							subclass: '6.2类 感染性物质',
							name: '',
							example: '病菌、病毒',
							unNumber: 'UN2811 / UN2913',
						},
					],
				},
				{
					class: '7类<br>放射品',
					name: '',
					note: '根据辐射水平分为I-III类',
					example: '医用类、工业用途',
				},
				{
					class: '8类<br>腐蚀品',
					name: '',
					example: '七氟丁酸',
					unNumber: 'UN2794 / UN1830',
				},
				{
					class: '9类<br>杂项危险品物质和物品对环境有危害',
					name: '',
					example: '摩托车、化工品',
					unNumber: 'UN1845 / UN3090',
				}
			],
			notes: {
				title: '重要处理说明',
				items: [
					'危险品运输需要提供危包',
					'包装必须符合DGR要求',
					{
						title: '冲突类别不可共同运输',
						items: ['3≠5.1', '4.2≠5.1', '4.3≠8']
					}
				]
			}
		},

		special: {
			title: '特殊货物',
			description: '定制化特殊货物运输方案',
			items: [{
					icon: 'fas fa-temperature-low',
					name: '温控货物'
				},
				{
					icon: 'fas fa-gem',
					name: '高价值物品'
				},
				{
					icon: 'fas fa-dog',
					name: '活体动物'
				},
				{
					icon: 'fas fa-prescription-bottle-alt',
					name: '医药品'
				},
				{
					icon: 'fas fa-flask',
					name: '实验室样品'
				},
				{
					icon: 'fas fa-drumstick-bite',
					name: '易腐食品'
				},
				{
					icon: 'fas fa-pallet',
					name: '超大货物'
				},
				{
					icon: 'fa-solid fa-robot',
					name: '机器人'
				}
			]
		}
	},
	common: {
		example: '例如',
		unNumber: 'UN编号'
	},
	operableGoods: {
		title: "可操作货物种类",
		subtitle: "专业处理各类货物运输需求",
		generalCargo: {
			title: "普货运输",
			description: "常规货物安全运输解决方案",
			items: "精细化工、原料药、生物制品材料、农药、机械配件、食品、服装等",
			tags: ["精细化工", "原料药", "生物制药", "农药", "机械配件"]
		},
		dangerousGoods: {
			title: "危品运输",
			description: "专业危险品运输解决方案",
			types: [{
					class: "1类",
					name: "爆炸品",
					examples: "火药、雷管、烟花"
				},
				{
					class: "2类",
					name: "气体",
					examples: "压缩氧、液化气"
				},
				{
					class: "3类",
					name: "易燃液体",
					examples: "汽油、酒精、油漆"
				},
				{
					class: "4类",
					name: "易燃固体",
					examples: "硫磺、火柴"
				},
				{
					class: "5类",
					name: "氧化剂",
					examples: "双氧水、硝酸铵"
				},
				{
					class: "6类",
					name: "毒害品",
					examples: "农药、氰化物"
				},
				{
					class: "7类",
					name: "放射性物质",
					examples: "铀、钴60"
				},
				{
					class: "8类",
					name: "腐蚀品",
					examples: "硫酸、氢氧化钠"
				},
				{
					class: "9类",
					name: "杂项",
					examples: "锂电池、石棉"
				}
			]
		},
		specialGoods: {
			title: "特殊货物",
			description: "定制化特殊货物运输方案",
			items: [{
					name: "锂电池",
					icon: "battery-full"
				},
				{
					name: "汽车",
					icon: "car"
				},
				{
					name: "发动机",
					icon: "cog"
				},
				{
					name: "异形货物",
					icon: "box-open"
				},
				{
					name: "超大件货物",
					icon: "radiation"
				}
			]
		}
	},
	recruitmentTitle: "加入泛思特国际运输",
	recruitmentIntro: "我们正在寻找充满激情、富有才华的专业人士加入我们的团队。在这里，您将有机会在全球物流领域发挥您的才能，与行业精英共事，共同推动物流行业的创新与发展。",
	joinUs: {
		filterTitle: '筛选条件',
		department: '部门',
		location: '工作地点',
		jobType: '职位类型',
		allDepartments: '全部部门',
		allLocations: '全部地点',
		allJobTypes: '全部类型',
		departments: [ '销售部', '航线部','客服部','操作部'],
		sales: '销售部',
		marketing: '市场部',
		service: '客服部',
		tech: '航线部',
		fullTime: '全职',
		partTime: '兼职',
		internship: '实习',
		beijing: "北京",
		shanghai: "上海",
		guangzhou: "广州",
		zhengzhou: "郑州",
		chengdu: "成都",
		openPositions: '开放职位',
		positionsAvailable: '个职位',
		viewDetails: '查看详情',
		noJobsFound: '未找到符合条件的职位',
		search: '搜索',
		resetFilters: '重置',
		departmentLabel: '部门：',
		locationLabel: '工作地点：',
		typeLabel: '职位类型：',
		howToApply: '如何申请',
		contactPrompt: '如果您对该职位感兴趣，请通过以下方式联系我们：',
		jobs: [{
				id: 1,
				title: '国内/海外销售',
				department: '销售部',
				location: '北京',
				type: '全职',
				description: '<h3>职位描述</h3><ul><li>负责国内/国际出口空运业务的客户开发与维护,通过网络、电话、拜访等多渠道拓展潜在客户</li><li>协助主管完成询价、报价及方案对接</li><li>跟进客户出货全流程,保障服务质量</li></ul><h3>任职要求</h3><ul><li>海外销售:全日制本科及以上学历,英语六级及以上可作为工作语言;学习能力强、有海外销售经验优先</li><li>国内销售:全日制统招大专及以上学历,有B端销售经验优先;有一定的英语基础及良好的沟通能力</li></ul>'
			},
			{
				id: 2,
				title: '航线辅订',
				department: '航线部',
				location: '北京',
				type: '全职',
				description: '<h3>职位描述</h3><ul><li>负责航班查询、系统订舱,辅助处理细节工作</li><li>按照工作流程做好限时查询、及时告知</li><li>熟悉各个航司的专用网站,特殊情况时熟悉处理流程</li></ul><h3>任职要求</h3><ul><li>全日制一本及以上学历,有英语基础</li><li>工作主动、责任心强、认真严谨、思路清晰,具有独立完成任务的能力</li></ul>'
			},
			{
				id: 3,
				title: '出口客服',
				department: '客服部',
				location: '北京',
				type: '全职',
				description: '<h3>职位描述</h3><ul><li>接受客人托书、发进仓图;与销售确认价格,并根据到货时间合理安排订舱</li><li>到货核查照片及按客户要求下达包装指令,包装完成后需核对照片并与客户确认</li><li>操作交单完成进行每票货物的账单审核,与客户确认账单无误后安排开票</li><li>单据处理:提单确认件、危品申报文件、报关文件、随机和随货文件、新作鉴定或换证等</li></ul><h3>任职要求</h3><ul><li>全日制本科及以上学历,物流、国贸专业优先</li><li>工作主动、责任心强、认真严谨,有学习能力、沟通能力及抗压力</li></ul>'
			},
			{
				id: 4,
				title: '申报/制单',
				department: '操作部',
				location: '北京',
				type: '全职',
				description: '<h3>职位描述</h3><ul><li>查询交接单内容,依照鉴定和DGR查询交接单内容、内外包装是否符合空运规则</li><li>根据航司和地面分开制作单据</li><li>在托书界面按照流程单查询的要求,在相应的位置输入代码和鉴定结论</li><li>录入CCSP时要按照制单的运单来维护信息(件数、重量、费率、尺寸、体积、品名等)</li></ul><h3>任职要求</h3><ul><li>全日制本科及以上学历,物流、国贸专业优先</li><li>工作主动、责任心强、认真严谨,有学习能力</li></ul>'
			}
		],
		sendResume: '简历请投递至邮箱',
		benefits: '我们为您提供',
		benefitList: [
			'有竞争力的薪资福利',
			'职业成长与培训机会',
			'灵活的假期与休假制度',
			'开放包容的工作环境'
		],
		benefitTitles: ['薪资福利', '成长培训', '假期安排', '团队文化'],
			benefitsTitle: '员工关怀与成长',
			ctaHeading: '期待与您同行',
			ctaDescription: '如果您希望在充满活力与挑战的货代行业施展才华，请将简历发送至',
			typeClassMap: {
				'全职': 'job-full-time',
				'兼职': 'job-part-time',
				'实习': 'job-internship',
				'Full-Time': 'job-full-time',
				'Part-Time': 'job-part-time',
				'Internship': 'job-internship'
			}
	},
	aboutUS: {
		title: "联系我们",
		description: "泛思特是一家拥有15年以上国际货运经验的全球领先物流供应商。",
		mission: "我们的使命",
		missionContent: "提供创新可靠的运输解决方案，为全球客户创造价值。",
		vision: "我们的愿景",
		visionContent: "成为全球供应链管理中最值得信赖的合作伙伴。",
		values: "我们的价值观",
		valuesList: [
			"客户至上",
			"诚信透明",
			"创新卓越",
			"团队协作"
		],
		history: "发展历程",
		historyContent: [
			"2008年成立于上海，最初只有5名员工",
			"2015年业务扩展至10个国家",
			"2020年在香港证券交易所上市",
			"目前在25个国家开展业务，拥有2000多名员工"
		],
		team: "我们的团队",
		teamContent: "我们拥有一支经验丰富、具备深厚行业知识和全球视野的专业团队。"
	},
	contactInfo: {
		title: "联系我们",
		ourContact: "我们的联系方式",
		address: "公司地址",
		companyAddress: "北京市顺义区机场北街8号院2幢7层E706-E712",
		viewMap: "查看地图",
		phone: "联系电话",
		businessPhone: "业务咨询",
		customerService: "客户服务",
		email: "电子邮箱",
		businessEmail: "业务咨询",
		customerServiceEmail: "客户服务",
		followUs: "关注我们",
		wechatQR: "微信公众号二维码",
		scanQR: "扫码关注公众号",
		onlineConsultation: "在线咨询",
		name: "姓名",
		namePlaceholder: "请输入您的姓名",
		company: "公司名称",
		companyPlaceholder: "请输入您的公司名称",
		emailPlaceholder: "请输入您的电子邮箱",
		phonePlaceholder: "请输入您的联系电话",
		subject: "咨询主题",
		selectSubject: "请选择咨询主题",
		airFreight: "航空货运",
		seaFreight: "海运服务",
		customsClearance: "报关服务",
		other: "其他",
		message: "咨询内容",
		messagePlaceholder: "请详细描述您的需求...",
		submitting: "提交中...",
		submit: "提交咨询",
		submitSuccess: "感谢您的咨询！我们会尽快与您联系。",
		globalOffices: "全国办事处",
		offices: [{
				id: 1,
				city: "北京",
				country: "中国",
				address: "北京市顺义区机场北街8号院2幢7层E706-E712",
			},
			{
				id: 2,
				city: "上海",
				country: "中国",
				address: "上海市浦东新区施湾八路1026号5号楼2楼",
			},
			{
				id: 3,
				city: "广州",
				country: "中国",
				address: "广州市花都区花东镇空港大道9号电商国际产业园（A8栋）305室",
			},
			{
				id: 4,
				city: "郑州",
				country: "中国",
				address: "河南郑州新郑市薛店镇云港路与华夏大道辅路交叉口西200米世航之窗大厦B座807室",
			},
			{
				id: 5,
				city: "成都",
				country: "中国",
				address: "成都市简阳市天府国际机场国际货运区中航货站进港210室",
			}
		],
		countries: {
			china: "中国",
			singapore: "新加坡",
			japan: "日本",
			usa: "美国"
		},
	},
	consultationSection: {
		tag: "增值服务",
		sectionTitle: "产品合规咨询",
		sectionDescription: "为您的货物提供全球合规的专业咨询服务",
		services: {
			dataService: {
				category: "数据服务",
				title: "自有强大数据库",
				// text: "实时更新的国际运输法规数据库，覆盖190+国家地区，每月5000+条数据更新",
				features: [
					"累计化学产品结论储存量达20万+",
					"累计当年产品HS结论储存量达3万+",
					"日新增数据200+条",
				]
			},
			certificationService: {
				category: "认证服务",
				title: "权威鉴定报告",
				// text: "与全球20+认证机构合作，提供具有法律效力的鉴定报告，24小时快速出证",
				features: [
					"国际航空运输协会（IATA）运输资质认可",
					"CNAS中国认可检验",
					"与多家鉴定机构合作，快速出证",
				]
			},
			mobileApp: {
				category: "移动服务",
				title: "自查鉴定小程序——鉴定宝",
				// text: "全球首款整合多式联运合规要求的专业工具，已服务于10,000+企业，助力高效、安全、合规运输。",
				features: [
					"鉴定数据世界的超级引擎",
					"货物结论及危品包装要求查询",
				]
			}
		},
		partnersSectionTitle: "权威认证机构",
		partners: [
			{
				name: "中国海关",
				alt: "中国海关"
			},
			{
				name: "迪捷姆",
				alt: "迪捷姆"
			},
			{
				name: "信诺递捷",
				alt: "信诺递捷"
			},
			{
				name: "上海化工",
				alt: "上海化工"
			},
			{
				name: "民航二所",
				alt: "民航二所"
			},
			{
				name: "天津津检",
				alt: "天津津检"
			}
		]
	},
	footer: {
		title: '期待与您共筑美好合作',
		brandDesc: '泛思特专注于提供无缝物流与运输解决方案，为您的业务需求量身定制。',
		contactPrompt: '欢迎随时联系我们，共同探索无限可能。',
		subscribePlaceholder: '输入邮箱地址订阅',
		subscribeBtn: '订阅',
		address: '北京市顺义区机场北街8号院2幢7层E706-E712',
		qq: '企业QQ：2355807082',
		phone: '13401038003',
		fax: '010-64564249',
		email: 'liuqian@fst.net.cn',
		copyright: '© 2026 泛思特国际运输 版权所有',
		columns: {
			quickLinks: '快速导航',
			contactInfo: '联系方式',
			followUs: '关注我们'
		},
		links: {
			home: '首页',
			about: '走进我们',
			shipping: '运输服务',
			refrigerated: '冷藏货物',
			operable: '操作性货物',
			consultation: '产品合规咨询',
			business: '商务合作',
			careers: '招贤纳士'
		},
		social: {
			fanstar: '泛思特小程序',
			fanstarHint: '微信扫一扫打开小程序',
			jdb: '鉴定宝小程序',
			jdbHint: '微信扫一扫打开鉴定宝',
			douyin: '抖音',
			xhs: '小红书'
		},
		beian: {
			publicSecurity: '京公网安备 11011302005688号',
			publicSecurityUrl: 'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11011302005688',
			icp: '京ICP备13034572号-1',
			icpUrl: 'https://beian.miit.gov.cn/#/Integrated/index'
		}
	},
	airlines: [{
			name: '德国汉莎航空',
			logo: 'LH.jpg'
		},
		{
			name: '国泰航空',
			logo: 'guotai.jpeg'
		},
		{
			name: '法荷航空',
			logo: 'Air-FranceKLM.png'
		},
		{
			name: '英国航空',
			logo: 'british-Airways.png'
		},
		{
			name: '加拿大航空',
			logo: 'jnd.jpg'
		},
		{
			name: '瑞士航空',
			logo: 'Swiss-Air.png'
		},
		{
			name: '中国东方航空',
			logo: 'china-eastern.png'
		},
		{
			name: '中国南方航空',
			logo: 'china-southern.jpg'
		},
		{
			name: '中国国际航空',
			logo: 'air-china.jpg'
		},
		{
			name: '海南航空',
			logo: 'hnhk.jpeg'
		},
		{
			name: '四川航空',
			logo: 'sichuan-air.png'
		},
		{
			name: '土耳其航空',
			logo: 'Turkey.jpg'
		},
		{
			name: '美国博立航空',
			logo: 'Boli-USA.jpg'
		},
		{
			name: '阿提哈德航空',
			logo: 'Etihad-Airways.jpg'
		},
		{
			name: '阿联酋航空',
			logo: 'ek.jpg'
		},
		{
			name: '大韩航空',
			logo: 'South-Korea.jpg'
		},
		{
			name: '美国航空',
			logo: 'usa.png'
		},
		{
			name: '新加坡航空',
			logo: 'Singapore.jpg'
		},
		{
			name: '波兰航空',
			logo: 'Poland.jpg'
		},
		{
			name: '卡塔尔航空',
			logo: 'qatar.jpg'
		},
		{
			name: '美国联合航空',
			logo: 'united.png'
		},
		{
			name: '俄国航空',
			logo: 'Russia.jpg'
		},
		{
			name: '泰国航空',
			logo: 'thai.jpg'
		},
		{
			name: '缅甸航空',
			logo: 'miandian.jpg'
		},
		{
			name: '航程未止',
			logo: 'gd.jpg'
		}
	],
	shippingLines: [{
			name: '马士基',
			code: 'MSK',
			logo: 'maersk.png'
		},
		{
			name: '中远',
			code: 'COSCO',
			logo: 'cosco.png'
		},
		{
			name: '达飞',
			code: 'CMA',
			logo: 'cmacgm.png'
		},
		{
			name: '海洋',
			code: 'ONE',
			logo: 'one.jpg'
		},
		{
			name: '阳明',
			code: 'YML',
			logo: 'yml.png'
		},
		{
			name: '地中海',
			code: 'MSC',
			logo: 'msc.png'
		},
		{
			name: '长荣',
			code: 'EMC',
			logo: 'evergreen.png'
		},
		{
			name: '万海',
			code: 'WHL',
			logo: 'wanhai.png'
		},
		{
			name: '东方海外',
			code: 'OOCL',
			logo: 'oocl.jpg'
		},
		{
			name: '航程未止',
			logo: 'gd.jpg'
		}
	],

	map: {
		title: "北京泛思特国际运输代理有限公司",
		googleMap: "在Google地图中查看",
		baiduMap: "在高德地图中查看",
		companyLocation: "公司位置",
	},

	homeHero: {
		slides: [
			{
				alt: '航空货运',
				badge: '物流运输',
				headline: '全球航空货运<br/>专业服务商',
				desc: '覆盖全球20+航空公司，为您提供高效、安全的航空物流解决方案。',
				cta: '我们的服务'
			},
			{
				alt: '危险品运输',
				badge: '专业运输',
				headline: '危险品运输<br/>安全无忧',
				desc: '20年危险品运输经验，专业团队全程管控，覆盖9类危险品分类，安全合规运输。',
				cta: '获取方案'
			},
			{
				alt: '冷链运输',
				badge: '冷链物流',
				headline: '医药化工<br/>冷链专家',
				desc: '专业冷链设备与技术团队，全程温控监测，确保药品、化工品运输安全稳定。',
				cta: '服务详情'
			}
		],
		mapHint: '点击城市标记查看详情',
		branches: {
			beijing: { contact: '销售总监：刘经理', phone: '电话：13401038003', address: '地址：北京市顺义区机场北街8号院2幢7层E706-E712' },
			shanghai: { contact: '分公司经理：宋经理', phone: '电话：13811318691', address: '地址：上海市浦东新区施湾八路1026号5号楼2楼' },
			guangzhou: { contact: '分公司经理：刘经理', phone: '电话：13001045512', address: '地址：广州市花都区花东镇空港大道9号电商国际产业园（A8栋）305室' },
			zhengzhou: { contact: '分公司经理：何经理', phone: '电话：15011588571', address: '地址：河南郑州新郑市薛店镇云港路与华夏大道辅路交叉口西200米世航之窗大厦B座807室' },
			chengdu: { contact: '分公司经理：梁经理', phone: '电话：17603339763', address: '地址：成都市简阳市天府国际机场国际货运区中航货站进港210室' }
		},
		provinceNames: { beijing: '北京', shanghai: '上海', guangzhou: '广东', zhengzhou: '河南', chengdu: '四川' }
	},

	businessPage: {
		heroSubtitle: '无论您有任何运输与物流需求，我们的专业团队随时为您提供定制化解决方案',
		companyAddressLabel: '公司地址',
		phoneLabel: '联系电话',
		primaryPhone: '134 0103 8003',
		landlinePhone: '010-8048-6231',
		emailLabel: '电子邮箱',
		contactEmail: 'liuqian@fst.net.cn',
		sendEmail: '发送邮件',
		mapUnavailable: '地图暂时无法加载',
		mapReload: '重新加载',
		headquartersAddressTitle: '总部地址',
		getDirections: '获取导航路线',
		directPhoneTitle: '电话直连',
		landlineWithLabel: '座机：010-8048-6231',
		onlineContactTitle: '在线联系',
		viewInGoogleMaps: '在Google地图中查看',
		viewInAmap: '在高德地图中查看',
		officesDescription: '覆盖全国核心物流枢纽城市，为您提供高效、便捷的本地化服务',
		officeTagHeadquarters: '总部',
		officeTagEastChina: '华东区域',
		officeTagSouthChina: '华南区域',
		officeTagCentralChina: '中部区域',
		officeTagSouthwestChina: '西南区域',
		mapErrorRateLimit: 'API 日调用量已达上限，请明日再试或更换 Key',
		mapErrorUnavailable: '地图服务暂不可用，请稍后再试',
		amapSearchKeyword: '泛思特'
	},

	servicesPage: {
		emergency: {
			title: '需要紧急帮助？',
			description: '我们的专业团队随时为您提供7×24小时的全方位物流支持'
		},
		cta: {
			title: '定制化物流解决方案',
			description: '根据您的业务需求，量身打造最优运输方案，降低成本、提升效率。'
		},
		scrollHint: {
			text: '即将进入下一个服务'
		}
	},
}